import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const ToastContext = createContext(null);
export function ToastProvider({ children, toastInstance }) {
    return _jsx(ToastContext.Provider, Object.assign({ value: toastInstance }, { children: children }));
}
export function useToast() {
    const state = useContext(ToastContext);
    if (state === null)
        throw new Error('Cannot find ToastProvider');
    return state;
}
